<div class="title" mat-dialog-title>
    <span> Are you sure you want to delete this set variant? </span>
</div>
<mat-dialog-actions>
    <button mat-button class="clear" (click)="deleteVariant()" tabindex="-1">
        Yes, delete
    </button>
    <button
        mat-button
        class="cancel"
        (click)="cancelDeleteVariant()"
        tabindex="-1"
    >
        No, cancel
    </button>
</mat-dialog-actions>
